import { Color, Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface CegidIntegrationStatusHeaderProps {
  tooltip: string
}

export const CegidIntegrationStatusHeader = ({ tooltip }: CegidIntegrationStatusHeaderProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex gap={Spacing.S4}>
      <Text>{t('cegid_integration_status.header')}</Text>
      <Tooltip label={tooltip} placement="top">
        <Styled.InfoIconWrapper>
          <Icon color={Color.Grey950} icon="info" />
        </Styled.InfoIconWrapper>
      </Tooltip>
    </Flex>
  )
}
